// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { RequestQuoteApiParameter, submitRequestQuoteService } from "@conklin/App/Services/RequestQuoteService";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type HandlerType = ApiHandler<
    RequestQuoteApiParameter & HasOnSuccess<RequestQuoteApiParameter> & HasOnError<string>,
    ServiceResult<RequestQuoteApiParameter>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const SubmitDataToApi: HandlerType = async props => {
    props.apiResult = await submitRequestQuoteService(props.apiParameter as RequestQuoteApiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch({
            type: "xRequestQuote/update",
            data: {
                ...props.parameter,
            },
        } as any);
        props.parameter.onSuccess?.(props.parameter);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [PopulateApiParameter, SubmitDataToApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const xngSubmitQuote = createHandlerChainRunner(chain, "XngSubmitQuote");
export default xngSubmitQuote;
